const DELIVERY_PLATFORMS: Record<string, string> = {
  meta: 'Meta', google: 'Google', tiktok: 'TikTok', snapchat: 'Snapchat',
  bing: 'Bing', criteo: 'Criteo', applovin: 'AppLovin', rtb: 'RTB',
};

export function deliveryFreshnessPlatform(page: string) {
  const prefix = 'ad-analysis/ad-dashboard/';
  if (!page.startsWith(prefix)) return null;
  const platform = page.slice(prefix.length);
  return DELIVERY_PLATFORMS[platform] ? { platform, label: DELIVERY_PLATFORMS[platform] } : null;
}
export function supportsAdDataFreshness(brand: string, siteCode: string) {
  return (brand === 'vooglam' && siteCode === 'us-vooglam')
    || (brand === 'zeelool' && siteCode === 'us-zeelool');
}
